import React from 'react';
import MasterLayout from '../components/layouts/MasterLayout';
import PageContentLayout from '../components/layouts/PageContentLayout';
import { HELP_URL } from '../config';
import { useTranslation } from 'react-i18next';

const HelpPage = () => {
    const { t } = useTranslation();
    return (
        <PageContentLayout title={t('menu.help')} icon='help-icon'>
            <iframe
                title={t('menu.help')}
                src={HELP_URL}
                frameborder="0"
                allowfullscreen
                className='external-data'
                style={{ height: '65vh' }}
            ></iframe>
        </PageContentLayout>
    );
};

export default HelpPage;
